import {
  MilestoneActionButtons,
  MilestoneAttributeDisplay,
  MilestoneDates,
  MilestonePanelExpanded,
  MilestonePanelHeaderSection,
} from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { CONTENT_WIDTH } from "@/enums";
import { useMilestoneDrawer } from "@/hooks/useAppMedia";
import { projectMilestoneType } from "@/propTypes";
import { Col, Row } from "antd";
import { bool, func, number, object, string } from "prop-types";
import { MilestoneActionDrawer } from "./MilestoneActionDrawer";
import { MilestoneActionCol } from "./styled";

export const MilestonePanelLayoutDesktop = ({
  milestone,
  childLevel,
  maxChildLevel,
  expanded,
  toggleExpanded,
  parentId,
  toggleChildren,
  targetDatesRequired,
  skuRequired,
  canUser,
  project,
  setProject,
  isAdmin,
}) => {
  return (
  <Row style={{ paddingBottom: 5 }}>
    <Col flex={1}>
      <S.StyledPanelRowDesktop $indent={`${childLevel * 40}px`}>
        <Col flex={1}>
          <S.StyledContentCard
            $status={milestone.status}
            styles={{ body: { height: "65px", padding: "0px 0px 0px 10px" } }}
          >
            <Row align={"middle"} style={{ height: "100%" }}>
              <Col xs={CONTENT_WIDTH.fiveTwelfths}>
                <S.MinWidthDiv $min={174}>
                  <MilestonePanelHeaderSection
                    milestone={milestone}
                    childLevel={childLevel}
                    expanded={expanded}
                    toggleExpanded={toggleExpanded}
                    toggleChildren={toggleChildren}
                  />
                </S.MinWidthDiv>
              </Col>
              <S.OffsetCol flex="auto" $indent={`${childLevel * 24}px`}>
                <S.MinWidthDiv $min={294}>
                  <MilestoneDates
                    milestone={milestone}
                    canUser={canUser}
                    project={project}
                    setProject={setProject}
                  />
                </S.MinWidthDiv>
              </S.OffsetCol>
              {useMilestoneDrawer() ? (
                <MilestoneActionCol>
                  <MilestoneAttributeDisplay
                    milestone={milestone}
                    targetDatesRequired={targetDatesRequired}
                    skuRequired={skuRequired}
                  />
                  <MilestoneActionDrawer
                    milestone={milestone}
                    childLevel={childLevel}
                    maxChildLevel={maxChildLevel}
                    parentId={parentId}
                  />
                </MilestoneActionCol>
              ) : (
                <MilestoneActionCol>
                  <MilestoneActionButtons
                    data-test-id={`milestone-actions-dropdown-${milestone.id}`}
                    milestone={milestone}
                    childLevel={childLevel}
                    maxChildLevel={maxChildLevel}
                    parentId={parentId}
                  />
                  <MilestoneAttributeDisplay
                    milestone={milestone}
                    targetDatesRequired={targetDatesRequired}
                    skuRequired={skuRequired}
                  />
                </MilestoneActionCol>
              )}
            </Row>
          </S.StyledContentCard>
        </Col>
      </S.StyledPanelRowDesktop>
      {expanded && (
        <div>
          <S.StyledContentCardExpansion>
            <MilestonePanelExpanded
              milestone={milestone}
              skuRequired={skuRequired}
            />
          </S.StyledContentCardExpansion>
        </div>
      )}
    </Col>
  </Row>
  );
};

MilestonePanelLayoutDesktop.propTypes = {
  milestone: projectMilestoneType,
  childLevel: number,
  maxChildLevel: number,
  expanded: bool,
  toggleExpanded: func,
  parentId: string,
  toggleChildren: func,
  targetDatesRequired: bool,
  skuRequired: bool,
  canUser: func,
  project: object,
  setProject: func,
  isAdmin: bool,
};
